export default "__VITE_ASSET__BEjkz01y__"